import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`;

const HowTagsWorkBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`;

const SectionHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: var(--size-gap-8);
`;

const HeaderSubText = styled.div`
  color: var(--color-accent-primary-default);
  font-size: 14px;
`;

export { HeaderSubText, HowTagsWorkBody, SectionHeader, Wrapper };
